import './UserItem.css';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import classNames from 'classnames';
import { Col } from 'react-bootstrap';
import { Organization, Owner } from '../../models/generics';

type Props = {
  user?: Owner;
  organization?: Organization;
  className?: string;
  title?: string;
  subtitle?: string;
}

export default function UserItem({ user, organization, className, title, subtitle }: Props) {
  return (
    <div className={classNames('user-item', className)}>
      <div className="user-avatar">
        <FontAwesomeIcon icon={solid('user')} />
      </div>
      <Col className="user-info">
        <h6 className="mb-0">{title || user?.name}</h6>
        {(subtitle || organization) && <span className="user-organization">{subtitle || organization?.name}</span>}
      </Col>
    </div>
  )
}
